export { default } from './JournalTeaser';
